import { profileService } from './profileService';

export type TourPhase = 
  | 'HOME'
  | 'LIBRARY_HUB'
  | 'LIBRARY'
  | 'LIBRARY_ONLINE'
  | 'AUDIOBOOKS'
  | 'READER'
  | 'NOTES_MODAL'
  | 'NOTES_PAGE'
  | 'STUDY_HUB'
  | 'FLASHCARDS'
  | 'PRONUNCIATION'
  | 'WRITING'
  | 'VOZ_ATIVA'
  | 'COMMUNITY_HUB'
  | 'FRIENDS'
  | 'CHAT'
  | 'COMMUNITY_FEED'
  | 'BOOK_CLUB'
  | 'PERSONAL_HUB'
  | 'STATISTICS'
  | 'ACHIEVEMENTS'
  | 'SETTINGS'
  | 'PROFILE'
  | 'DONE';

export const tourService = {
  startTour(isPassive: boolean = false, initialPhase: TourPhase = 'HOME') {
    localStorage.setItem('libritui_tour_active', 'true');
    localStorage.setItem('libritui_tour_passive', isPassive ? 'true' : 'false');
    this.setPhase(initialPhase);
    window.dispatchEvent(new Event('libritui-tour-started'));
  },

  stopTour() {
    localStorage.setItem('libritui_tour_active', 'false');
    localStorage.removeItem('libritui_tour_phase');
    try {
      const activeDriver = (window as any)._activeDriver;
      if (activeDriver) activeDriver.destroy();
    } catch(e) {}
    window.dispatchEvent(new Event('libritui-tour-stopped'));
  },

  nextStep() {
    window.dispatchEvent(new Event('libritui-tour-next'));
  },

  async finishTour(userId?: string) {
    this.stopTour();
    localStorage.setItem('libritui_tour_done', 'true');
    if (userId) {
      await profileService.updateProfile(userId, { tutorial_completed: 'yes' });
    }
  },

  isActive() {
    return localStorage.getItem('libritui_tour_active') === 'true';
  },

  isPassive() {
    return localStorage.getItem('libritui_tour_passive') === 'true';
  },

  getPhase(): TourPhase {
    return (localStorage.getItem('libritui_tour_phase') as TourPhase) || 'DONE';
  },

  setPhase(phase: TourPhase) {
    localStorage.setItem('libritui_tour_phase', phase);
  },

  createDriver(steps: any[], onComplete?: () => void) {
    const isPassive = this.isPassive();
    
    // Custom button texts mapped for the native component
    const finalSteps = steps.map(s => ({
      ...s,
      popover: {
        ...s.popover,
        doneBtnText: s.popover?.doneBtnText || 'Próximo',
        nextBtnText: s.popover?.nextBtnText || 'Próximo',
        prevBtnText: 'Anterior',
        showButtons: s.popover?.showButtons !== undefined ? s.popover.showButtons : ['next']
      }
    }));

    window.dispatchEvent(new CustomEvent('libritui-native-tour', {
       detail: { steps: finalSteps, onComplete }
    }));
    
    return true;
  }
};
